import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceWorkflowSchemeProjectLimitRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-workflow-scheme-project-limit',
	path: '/jira/settings/system/performance/metrics/workflow/projectlimit',
};
